import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexRow, FlexRowCenterVertical, TextP } from '../../..';
import { CountSetter } from '../Product/CountSetter';
import { StockInfo } from '../Product/StockInfo';
import { BigButtonWithRequest } from '../Product/BigButtonWithRequest';
import { FavoriteCompare } from './FavoriteCompare';
import { Watching } from '../Product/Watching';

interface Props {
  price: number;
  oldPrice: number;
  sale: boolean;
  salePercentage: number;
  currency: string;
  avail_id: number;
  availability: string;
  count: number;
  addToCart: any;
  handleCountChange: (newValue) => void;
}

function ProductDetailPriceCart({
  price,
  oldPrice,
  sale,
  salePercentage,
  currency,
  avail_id,
  availability,
  count,
  addToCart,
  handleCountChange,
}: Props) {
  const unAvailable = avail_id === 11 || !avail_id;
  return (
    // Autorádio CD,MP3,USB červené podsv. 2x pre-out
    <>
      <Wrapper avail_id={avail_id}>
        <PriceRow>
          {unAvailable ? (
            <Soon>{`UŽ ČOSKORO`}</Soon>
          ) : (
            <>
              <Price avail_id={avail_id}>{`${price} ${currency}`}</Price>
              {sale && (
                <OldPrice>{`Pôvodná cena: ${oldPrice} ${currency} (-${salePercentage}%)`}</OldPrice>
              )}
            </>
          )}
        </PriceRow>
        <ButtonsRow>
          {unAvailable ? (
            <Watching />
          ) : (
            <>
              <CountSetter
                count={count}
                onChange={handleCountChange}
                hasMarginRight={true}
              />
              <BigButtonWithRequest
                avail_id={avail_id}
                onButtonClick={addToCart}
              />
            </>
          )}
          <FavoriteCompare />
        </ButtonsRow>
        <StockInfo avail_id={avail_id} availability={availability} />
      </Wrapper>
    </>
  );
}

const Wrapper = styled.div<{ avail_id: number }>`
  padding: ${rem(24)};
  background-color: ${({ theme, avail_id }) =>
    avail_id === 1
      ? theme.colors.stockCountAvailableFair
      : avail_id === 2
      ? theme.colors.stockCountSoldFair
      : theme.colors.stockCountUnavailableFair};
`;

const PriceRow = styled(FlexRow)`
  justify-content: space-between;
  margin-bottom: ${rem(16)};
`;

const ButtonsRow = styled(FlexRowCenterVertical)`
  margin-bottom: ${rem(16)};
`;

const Price = styled(TextP)<{ avail_id: number }>`
  font-size: ${rem(24)};
  font-weight: 500;
  color: ${({ theme, avail_id }) =>
    avail_id === 1
      ? theme.colors.stockCountAvailable
      : avail_id === 2
      ? theme.colors.stockCountSold
      : theme.colors.textPrimary};
`;

const OldPrice = styled(TextP)``;

const Soon = styled(TextP)`
  font-weight: 500;
  font-size: ${rem(24)};
`;

export { ProductDetailPriceCart };
